import { Component } from '@angular/core';

@Component({
  selector: 'usucampeao-projeto-relatorio-tecnico-lepac',
  templateUrl: './projeto-relatorio-tecnico-lepac.component.html',
  styleUrls: ['./projeto-relatorio-tecnico-lepac.component.scss'],
})
export class ProjetoRelatorioTecnicoELepacComponent { }
